const HOURS_FIELDS = ['transitHours']

export const getTransitHours = (rate: any): number | null => {
  if (!rate) return null
  for (const field of HOURS_FIELDS) {
    const value = rate[field] ?? rate?.extraInfo?.[field]
    if (value === 0 || value) return Number(value)
  }
  return null
}

// DOT / Non-DOT vendors (DOTRegMileage set) return transit time in hours from REST.
export const isDotRegVendor = (vendor: any): boolean => vendor?.DOTRegMileage != null

export const findRateVendor = (rate: any, enabledVendors?: any[]): any =>
  enabledVendors?.find((v: any) => v?.id === rate?.vendorId)

const formatHours = (hours: number): string =>
  Number.isInteger(hours) ? String(hours) : String(Math.round(hours * 100) / 100)

// Shows "<n>h" for DOT/Non-DOT vendors; otherwise keeps transit in days.
// Without enabledVendors (e.g. Quotes Grid) we fall back to hours when REST returned them.
export const formatTransit = (rate: any, enabledVendors?: any[]): string => {
  const hours = getTransitHours(rate)
  const showHours = enabledVendors
    ? isDotRegVendor(findRateVendor(rate, enabledVendors))
    : hours !== null

  if (showHours && hours !== null) {
    return `${formatHours(hours)}h`
  }
  return rate?.transitDays ?? '-'
}

/** Normalized transit in fractional days for sorting. Unknown ("-") goes to the bottom. */
export const getTransitInDays = (rate: any): number => {
  const hours = getTransitHours(rate)
  if (hours !== null) return hours / 24
  const days = rate?.transitDays
  return days === '-' || days == null ? Number.MAX_SAFE_INTEGER : Number(days)
}
